// extracted by mini-css-extract-plugin
export default {"additional-materials__text":"style_additional-materials__text__Ih88J"};